import { StudySearchStrategy } from './searchStrategy.model';

export class KeywordsExtracted {
  public keywordsExtractedId: number;
  public studySearchStrategyId: number;
  public keyword: string;
  public pos: string;
  public rank: number;
  public count: number;
  public keywordTypeId?: number;
  public isCustomKeyword: boolean;

  public studySearchStrategy: StudySearchStrategy;
}
